export const WebSocket = globalThis.WebSocket;
export const MessageEvent = globalThis.MessageEvent;
export const crypto = globalThis.crypto;
